import React from 'react'
import {isEmpty} from 'lodash'
import {Redirect} from 'react-router-dom'

import errors from '../../lib/errors.js'
import FormulaCard from './FormulaCard'
import FormulaNotFound from './FormulaNotFound'
import BackButton from '../UI/BackButton'
import PageTitle from '../UI/PageTitle'
import LinearLoader from '../UI/LinearLoader'

import Resource from '../../stores/resource'
const FormulaStore = Resource('formulas')


class ShowFormulaPage extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      formula: {},
      error: null,
      loading: true
    }
  }

  componentDidMount() {
    FormulaStore.find(this.props.match.params.id)
    .then((result) => this.setState({formula: result.data, loading: false}))
    .catch((error) => this.setState({formula: {}, error: errors.unpack(error), loading: false}))
  }

  _redirectTo = (url) => {
    this.setState({redirect: url})
  }

  render() {
    const {
      formula,
      loading,
      redirect
    } = this.state

    if (loading) return <LinearLoader />
    if (redirect) return <Redirect push to={redirect}/>
    if (isEmpty(formula)) return (<FormulaNotFound/>)

    return (
      <section>
        <header>
          <PageTitle>
            Formula
          </PageTitle>
        </header>
        <FormulaCard
          formula={formula}
          editCallback={() => this._redirectTo(`/formulas/${formula.id}/edit`)}
        />
        <br/>
        <BackButton/>
      </section>
    )
  }
}

export default ShowFormulaPage



// WEBPACK FOOTER //
// ./src/components/Formulas/ShowFormulaPage.jsx